import { Icon, Typography } from '@/components';
import { useState } from 'react';

export function DealPreparation() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-primary-100 mb-6 rounded-lg p-4 sm:p-6">
      <div className="mb-4 flex cursor-pointer items-center justify-between" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="flex-1 pr-4">
          <Typography as="h3" weight="semibold" size="title">
            Getting Started with Your Project Submission
          </Typography>
          <Typography as="p" className="mt-1" size="body-3">
            Follow these steps to prepare and publish your opportunity on nTeaser.
          </Typography>
        </div>
        <div className="inline-flex items-center justify-center rounded-full border border-neutral-50 p-2">
          <Icon
            name="chevron-down"
            className={`h-7 w-7 shrink-0 text-neutral-800 transition-transform duration-300 ${isExpanded ? '' : 'rotate-180'}`}
          />
        </div>
      </div>

      <div
        className={`grid overflow-hidden transition-all duration-300 ease-in-out ${
          isExpanded ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        }`}
      >
        <div className="overflow-hidden">
          <div className="space-y-6">
            {/* Grid responsive para los 3 pasos */}
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
              {/* Paso 1 */}
              <div className="rounded-lg bg-white p-4">
                <div className="mb-3 flex items-start gap-3">
                  <div className="bg-primary-700 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white">
                    1
                  </div>
                  <Typography as="h4" size="body-2" weight="semibold">
                    Add Your Opportunity Information
                  </Typography>
                </div>
                <Typography as="p" size="body-3" className="mb-2">
                  Start by completing the main details of your project and the type of transaction you wish to launch.
                  You can upload a single project or group several into one portfolio — we'll guide you through the
                  process.
                </Typography>
                <div className="space-y-1">
                  <Typography as="p" size="body-3">
                    • Basic project data (technology, location, capacity, permits)
                  </Typography>
                  <Typography as="p" size="body-3">
                    • Development stage and expected timeline
                  </Typography>
                  <Typography as="p" size="body-3">
                    • Deal structure and transaction details
                  </Typography>
                </div>
              </div>

              {/* Paso 2 */}
              <div className="rounded-lg bg-white p-4">
                <div className="mb-3 flex items-start gap-3">
                  <div className="bg-primary-700 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white">
                    2
                  </div>
                  <Typography as="h4" size="body-2" weight="semibold">
                    nTeaser Review & Deal Preparation
                  </Typography>
                </div>
                <Typography as="p" size="body-3" className="mb-2">
                  Our team will review your submission, refine the teaser, and prepare your project for publication.
                  We'll contact you directly to validate information, improve documentation, and ensure your deal is
                  ready for investors.
                </Typography>
                <div className="space-y-1">
                  <Typography as="p" size="body-3">
                    • Documentation (NDA and VDR optional, to speed up)
                  </Typography>
                  <Typography as="p" size="body-3">
                    • Plan selection and teaser optimization
                  </Typography>
                  <Typography as="p" size="body-3">
                    • Teaser creation and final validation
                  </Typography>
                </div>
              </div>

              {/* Paso 3 */}
              <div className="rounded-lg bg-white p-4">
                <div className="mb-3 flex items-start gap-3">
                  <div className="bg-primary-700 flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white">
                    3
                  </div>
                  <Typography as="h4" size="body-2" weight="semibold">
                    Project Goes Live
                  </Typography>
                </div>
                <Typography as="p" size="body-3" className="mb-2">
                  Once approved, your project will be published on nTeaser and visible to our network of qualified
                  investors and buyers.
                </Typography>
                <div className="space-y-1">
                  <Typography as="p" size="body-3">
                    • Immediate exposure to active investors
                  </Typography>
                  <Typography as="p" size="body-3">
                    • Track views and engagement in real time
                  </Typography>
                  <Typography as="p" size="body-3">
                    • Receive and manage Expressions of Interest directly through the platform
                  </Typography>
                </div>
              </div>
            </div>

            {/* Tips for Success */}
            <div className="rounded-lg bg-white p-4">
              <div className="mb-3 flex items-center gap-2">
                <span className="text-warning-500 text-xl">💡</span>
                <Typography as="h4" size="body-2" weight="semibold">
                  Tips for Success
                </Typography>
              </div>
              <ul className="space-y-2">
                <li>
                  <Typography as="p" size="body-3">
                    • When building a portfolio, include projects of similar size, technology, and development stage,
                    ideally within the same region.
                  </Typography>
                </li>
                <li>
                  <Typography as="p" size="body-3">
                    • Define transparent financial terms early and stay consistent, as investors appreciate clarity and
                    reliability.
                  </Typography>
                </li>
                <li>
                  <Typography as="p" size="body-3">
                    • Keep your documentation well organized with a clear folder structure and consistent naming in your
                    VDR.
                  </Typography>
                </li>
                <li>
                  <Typography as="p" size="body-3">
                    • Stay proactive and responsive. Professional and timely communication builds trust and helps close
                    deals faster.
                  </Typography>
                </li>
                <li>
                  <Typography as="p" size="body-3">
                    • Count on the nTeaser team for full support. Our goal is to help you close the deal efficiently and
                    successfully.
                  </Typography>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
